(function (angular) {
    'use strict';

    angular.module('jwsp.util', []);
}(angular));
